export { default } from './Icon';



// WEBPACK FOOTER //
// ./src/design-system/atoms/Icon/index.jsx